import { InfoMessageBlock } from 'components';
import classNames from 'classnames';
import { useNavigationCallback } from 'hooks';
import { verificationStatusTypes } from 'config/types';
import { usePublicAccount } from 'state';
import styles from './AccountVerificationStatus.module.scss';

/**
 * AccountVerificationStatus
 *
 * @return {JSX.Element}
 */
const AccountVerificationStatus = ({ className }) => {
  const { data } = usePublicAccount();
  const { navigateToAndBackHere } = useNavigationCallback();
  const handleVerification = () => navigateToAndBackHere('/verification');

  return data.verificationStatus === verificationStatusTypes.VERIFIED ? null : (
    <InfoMessageBlock
      className={classNames(
        styles.AccountVerificationStatus,
        className,
        AccountVerificationStatus.displayName
      )}
      icon="verified"
      title={
        data.verificationStatus === verificationStatusTypes.PENDING
          ? 'Verification pending'
          : 'Verification required'
      }
      description={
        data.verificationStatus === verificationStatusTypes.PENDING
          ? 'You will receive a notification when one of our team has verified your account. Thank you for your patience.'
          : 'Tap here to verify. Then you can create a tenancy and list your property in our search area. Verification normally takes a few hours.'
      }
      black={data.verificationStatus !== verificationStatusTypes.PENDING}
      flip
      onClick={
        data.verificationStatus === verificationStatusTypes.PENDING
          ? undefined
          : handleVerification
      }
    />
  );
};

AccountVerificationStatus.displayName = 'AccountVerificationStatus';

export default AccountVerificationStatus;
